import script from "./TeamMembers.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamMembers.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__